export default {
  banners:[
    // imgUrl: '图片地址'， title: '标题文本', description: '描述信息', component: '跳转组件名称'
      {
        imgUrl: require('../../../assets/images/services/banner-16.jpg'),
        title: '人材・AI',
        description: '',
        component: ''
      }
  ],
  items:[
    {
        title: 'AI',
        description: 'データの海におけるAIが無限の可能性を切り開きます。',
      // title: '人力资源',
      // description:
      //   `<p style="font-size:1.05rem">maesinfo高科技人力资源服务是为客户提供各类型高品质、高科技人才，包括但不仅限于各种软件研发工程师
      //   </p><p>我们的优势:<br/>
      //   1) 海内外IT行业高科技人才服务<br/>
      //   2) 海内外高科技人才服务交付渠道Melinked.com
      //   </p>`
    },
    {
      title: 'お客様への価値提供',
      description: `<span class='img' style="background:url(`+require('../../../assets/images/services/pic-16.jpg')+`)"></span>
      <span class="list">
      <i> </i>国内外のITハイテク人材サービスの提供<br/ >
      <i> </i>人材提供プラットフォーム Melinked.com を通じたグローバルなデリバリーチャネル<br/ >      

      </span>`
    }
  ]
}
